import { createClient } from '@supabase/supabase-js';

// Allow localhost fallback in development
const supabaseUrl =
  process.env.NEXT_PUBLIC_SUPABASE_URL ||
  (process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:54321' : undefined);
const supabaseAnonKey =
  process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ||
  (process.env.NODE_ENV === 'development'
    ? 'sb_publishable_ACJWlzQHlZjBrEguHvfOxg_3BJgxAaH'
    : undefined);

// During build time, use placeholder values if env vars aren't set
// This allows the build to complete, but the app won't work until env vars are set
const buildTimeUrl = supabaseUrl || 'https://placeholder.supabase.co';
const buildTimeKey = supabaseAnonKey || 'placeholder-key';

if (!supabaseUrl || !supabaseAnonKey) {
  // During build, log a warning but continue
  if (typeof window === 'undefined') {
    console.warn(
      'Missing Supabase environment variables during build. Set NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_ANON_KEY in Vercel.'
    );
  } else {
    // In runtime, log error but don't throw - let the app render with error message
    console.error(
      'Missing required environment variables: NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_ANON_KEY must be set'
    );
  }
}

export const supabase = createClient(buildTimeUrl, buildTimeKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
});
